import React from "react";
import Dialog from "../../base/dialog";
import {Row} from "reactstrap";
import {alpha, Divider, useTheme} from "@mui/material";
import Barcode from 'react-barcode';
import Button from "../../base/button/button";
import JsBarcode from 'jsbarcode';


const SerialBarcodeDialog = ({
                                 open,
                                 setOpen,
                                 serial
                             }) => {
    const theme = useTheme();

    /**
     * Creates a canvas and then creates the barcode on that canvas, then downloads the barcode from user.
     * @param serialNumber
     */
    const downloadBarcode = (serialNumber) => {
        const canvas = document.createElement("canvas");
        JsBarcode(canvas, serialNumber, {format: "CODE39"});
        const link = document.createElement('a');
        link.href = canvas.toDataURL("image/png");
        link.download = `${serialNumber}_barcode.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    if (!serial || !open) {
        return '';
    }

    return (
        <Dialog
            open={open}
            setOpen={setOpen}
            maxWidth={serial.serialNumber.length > 12 ? 'md' : 'sm'}
        >
            <Row className='no-gutters justify-content-center align-items-start w-100'>
                <Row xs={12} className='no-gutters justify-content-center m-3 w-100'>
                    <p className={`text-lg text-color-1 my-2 font-weight-semi-bold text-center`}>
                        Serial Number
                    </p>
                </Row>
                <Divider className='divider'/>
                <div className='my-4 w-100'/>
                <div className='mx-4 w-100 row no-gutters align-items-center justify-content-center'>
                    <div
                        className={'bordered'}
                        style={{backgroundImage: theme.palette['app-specific'].dashedBorder(theme.shape.borderRadius, alpha(theme.palette.secondary.main, 0.2))}}
                    >
                        <Barcode
                            value={serial.serialNumber}
                            text={serial.serialNumber}
                            lineColor={theme.palette.secondary.main}
                            background={theme.palette.background.paper}
                            width={3}
                            height={150}
                            margin={20}
                        />
                    </div>
                </div>
                <div className='my-4 w-100'/>
                <Divider className='divider'/>
                <Row className='no-gutters justify-content-between align-items-start w-100'>
                    <Button
                        disabled={!open}
                        variant={'dialog'}
                        color={'primary'}
                        onClick={() => setOpen(false)}
                        borderRadius={'0 8px 0 8px'}
                    >
                        Close
                    </Button>
                    <Button
                        disabled={!open}
                        variant={'dialog'}
                        color={'primary'}
                        onClick={() => downloadBarcode(serial.serialNumber)}
                        borderRadius={'8px 0 8px 0'}
                    >
                        Download
                    </Button>
                </Row>
            </Row>
        </Dialog>
    );
}


export default SerialBarcodeDialog;
